import MyExpApi from "apps/myExperience/enum/MyExpApi";
import ContextEntityType from "shared/enums/ContextEntityType";
import ContextType from "shared/enums/ContextType";
import ApiPurchaseOrder from "shared/model/ApiPurchaseOrder";
import ApiPurchaseOrderRequest from "shared/types/ApiPurchaseOrderRequest";
import { useGetApiData } from "shared/datalayer";
import { HttpVerb } from "shared/utils/enums";

export function useGetAdditionalChargesList(registrationParticipantId: string) {
  const paramsReqObj: ApiPurchaseOrderRequest = {
    contextEntityType: ContextEntityType.PARTICIPANT,
    inventoryTypeFilter: [],
    contextType: ContextType.REGISTRATION,
    entityId: registrationParticipantId,
    registrationParticipantId: registrationParticipantId
  };
  return useGetApiData<Array<ApiPurchaseOrder>>(
    MyExpApi.ADDITIONAL_CHARGE,
    { method: HttpVerb.POST, body: paramsReqObj },
    { enabled: Boolean(registrationParticipantId) }
  );
}
